import { FONT_FAMILY_PRIMARY } from '../../config/brandTokens'

// Shared chart hover-tooltip styling — the single source of truth for the look
// used by the fleet-overview KPI sparkline and the Plotly telemetry charts: a
// dark surface with a hairline border, a muted date header over bold values,
// and a small dot on the hovered point.
export const HOVER_BG = 'rgba(18,20,23,0.97)'
export const HOVER_BORDER = 'rgba(255,255,255,0.12)'
export const HOVER_DATE_COLOR = 'rgba(255,255,255,0.6)'

// Plotly hoverlabel config matching the tokens above. Use with
// `hovermode: 'x unified'` so a single tooltip prints every visible trace at
// the hovered x.
export const universalHoverLabel = {
    bgcolor: HOVER_BG,
    bordercolor: HOVER_BORDER,
    font: { color: '#fff', size: 11, family: FONT_FAMILY_PRIMARY },
    align: 'left' as const,
}

// Date header format mirroring the sparkline's "ddd, MMM D" (adds the time for
// intraday/hourly series). Feed into `xaxis.hoverformat`.
export const universalHoverDateFormat = (granularity?: 'hour' | 'day') =>
    granularity === 'hour' ? '%a, %b %-d · %H:%M' : '%a, %b %-d'

// Transparent Plotly hoverlabel — hides the native tooltip text while keeping
// the on-line hover dots and x spike, so a custom HTML container can render the
// content instead.
export const universalHoverLabelHidden = {
    bgcolor: 'rgba(0,0,0,0)',
    bordercolor: 'rgba(0,0,0,0)',
    font: { color: 'rgba(0,0,0,0)', size: 1 },
}

// Floating tooltip container styling, matching the fleet-map hover tooltip
// (gradient surface, hairline border, soft shadow, blur). Spread onto an MUI
// `sx` for a custom chart/HTML tooltip.
export const HOVER_GRADIENT =
    'linear-gradient(180deg, rgba(30,32,36,0.97), rgba(18,20,23,0.97))'
export const HOVER_SHADOW = '0 10px 30px rgba(0,0,0,0.5)'
export const universalTooltipSx = {
    background: HOVER_GRADIENT,
    color: '#fff',
    borderRadius: '10px',
    border: `1px solid ${HOVER_BORDER}`,
    boxShadow: HOVER_SHADOW,
    backdropFilter: 'blur(6px)',
    fontSize: 12,
    lineHeight: 1.45,
    px: 1.25,
    py: 1,
    pointerEvents: 'none',
} as const
